import React from 'react';
import PropTypes from 'prop-types';

import OkendoReviewStars from '../OkendoReviewStars/OkendoReviewStars';

import { getSelectedVariantPrices, showPriceWithDecimalIfAvailable } from '../../Utils/PriceUtils';
import { getVendorName } from '../../Utils/ProductUtils';

import { HeaderGridDiv, StyledVendor, StyledHeaderContainer, StyledH1, StyledPriceWrapper, StyledCompareAtPrice } from './ProductHeaderStyles';

var ProductHeader = function ProductHeader(props) {
  var variantPrices = getSelectedVariantPrices(props.selectedVariant);
  var vendorName = getVendorName(props.product.brandName, props.product.vendor);

  return React.createElement(
    HeaderGridDiv,
    null,
    React.createElement(
      StyledVendor,
      null,
      vendorName
    ),
    React.createElement(
      StyledHeaderContainer,
      null,
      React.createElement(
        StyledH1,
        null,
        props.title
      ),
      React.createElement(
        StyledPriceWrapper,
        { isSale: variantPrices.isSaleVariant },
        variantPrices.isSaleVariant && React.createElement(
          StyledCompareAtPrice,
          null,
          React.createElement(
            's',
            null,
            showPriceWithDecimalIfAvailable(variantPrices.compareAtPrice)
          )
        ),
        React.createElement(
          'span',
          null,
          showPriceWithDecimalIfAvailable(variantPrices.price)
        )
      )
    ),
    props.productListingSnippet && props.productListingSnippet.value !== '<span></span>' && React.createElement(OkendoReviewStars, {
      okendoSnippet: props.productListingSnippet.value
    })
  );
};

ProductHeader.propTypes = {
  title: PropTypes.string.isRequired,
  vendor: PropTypes.string,
  selectedVariant: PropTypes.object.isRequired,
  nonReturnableVariant: PropTypes.bool.isRequired,
  ineligibleForDiscount: PropTypes.bool.isRequired,
  productListingSnippet: PropTypes.object
};

export default ProductHeader;